import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as LogRocket from 'logrocket';
import { AccountOutput, EnvironmentData } from 'src/app/shared/models';
import { AuthorizationService } from 'src/app/shared/services/authorization.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { Logger } from 'src/app/shared/services/logger.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { ToastService } from 'src/app/shared/services/toast.service';

@Component({
  selector: 'app-login-error',
  templateUrl: './login-error.component.html',
  styleUrls: ['./login-error.component.scss']
})
export class LoginErrorComponent implements OnInit {
  public username: string = '';
  public password: string = '';
  public error: boolean = false;
  public errMsg: string = '';
  public success: boolean = false;
  public successMsg: string = '';
  public delMsg: boolean = false;
  public isTerminated: boolean = false;
  public isValid: boolean = false;
  public isLoginWait: boolean = false;
  public message: string = '';
  public config: EnvironmentData;
  public encKey: string = '';
  public selectedAccountId: string = '';
  public dateTimePassedByAma: string = new Date().toString();
  public showUserDropdown: boolean = false;
  public display: string = 'none';
  public redirectURL: string = '';
  public fieldTextType: boolean;
  public aaId: string = '';
  public userCounter: {} = { "user": "", "counter": 0, "lastLog": "" };
  @ViewChild('dangerTpl', { static: false }) public dangerTpl: string;

  LoginForm = this.fb.group({
    username: [null, Validators.required],
    password: [null, Validators.required]
  })

  constructor(
    private router: Router,
    private toastService: ToastService,
    private authService: AuthorizationService,
    private cdr: ChangeDetectorRef,
    private globalwindowService: GlobalService,
    private logger: Logger,
    private loginService: LoginService,
    private fb: FormBuilder,
  ) { }

  public ngOnInit(): void {
    this.config = JSON.parse(sessionStorage.getItem('config'));
    sessionStorage.setItem('isPageLoadedFirstTime', 'true');
    this.errMsg = sessionStorage.getItem('errMsg');
    this.message = sessionStorage.getItem('delMsg');
    if (this.errMsg) {
      this.error = true;
      sessionStorage.removeItem('errMsg');
    }

    if (this.message) {
      this.delMsg = true;
      sessionStorage.removeItem('delMsg');
    }
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  submitData() {
    this.isLoginWait = true
    this.error = false;
    this.delMsg = false;
    this.isValid = true;
    this.success = false
    this.username = this.LoginForm.controls.username.value;
    if (this.username === null || this.username === undefined || this.username.length === 0) {
      this.isLoginWait = false
      this.error = true;
      this.errMsg = 'Please fill all required fields.';
      this.isValid = false;
      this.redirectURL = ''
    }

    if (this.isValid) {
      this.loginService.username_lookup(this.username).subscribe(res => {
        this.redirectURL = res['result']['sso_redirect_url'];
        if (this.redirectURL) {
          window.location.replace(this.redirectURL);
        } else {
          this.loginSubmit(res);
        }
      }, (err) => {
        this.loginSubmit(err);
      });
    }
  }

  loginSubmit(aaRes) {
    this.isValid = true;
    this.username = this.LoginForm.controls.username.value;
    this.password = this.LoginForm.controls.password.value;
    this.error = false;

    if (this.password === null || this.password === undefined || this.password.length === 0) {
      this.isLoginWait = false
      this.error = true;
      this.errMsg = 'Please fill all required fields.';
      this.isValid = false;
      return;
    } else if (aaRes['status'] === 1 || aaRes['status'] === '1') {
      this.isLoginWait = false
      this.isValid = false;
      this.error = true;
      this.userCounter = JSON.parse(sessionStorage.getItem("userCounter"));
      const now = new Date();
      let lastLog = new Date();
      if(this.userCounter['lastLog']) lastLog = new Date(this.userCounter['lastLog']);
      if (this.userCounter['prevUser'] && (this.userCounter['prevUser'].toLowerCase() === this.username.toLowerCase())) {
        this.userCounter['counter']++;
        if (this.userCounter['counter']%5 === 0) {
          this.userCounter['lastLog'] = new Date(now.getTime() + 15 * 60 * 1000);
          this.errMsg = 'You have reached the maximum number of attempts. Please try again after sometime.'
        } else if (lastLog > now) {
          this.userCounter['counter']--;
          this.errMsg = 'You have reached the maximum number of attempts. Please try again after sometime.'
        } else {
          this.userCounter['prevUser'] = this.username;
          this.errMsg = 'Invalid credentials.';
        }
      } else {
        this.userCounter['counter'] = 1;
        this.userCounter['prevUser'] = this.username;
        this.userCounter['lastLog'] = "";
        this.errMsg = 'Invalid credentials.';
      }
      sessionStorage.setItem("userCounter", JSON.stringify(this.userCounter))
      return;
    } else {
      this.loginService.checkUser({ "accId": aaRes['result']['account_id'] }).subscribe(res => {
        this.aaId = res['result']['aaId'];
        let counter = parseInt(res['result']['counter'], 10);
        let termDt = new Date(res['result']['term_dt']);
        const termDtUtc = termDt.getTime(); 
        let now = Date.now();  
        if ((counter > 0 && counter%5 === 0 && termDtUtc > now) || res['status'] === 1) {
          this.errMsg = 'You have reached the maximum number of attempts. Please try again after some time.';
          this.isValid = false;
          this.isLoginWait = false;
          this.error = true;
          return;
        } else {
          this.validate(aaRes);
        }
      })
    }
  }

  validate(aaRes) {
    let jsonData =
    {
      'username': this.username,
      'password': this.password
    };

    if (this.isValid) {
      this.success = true;
      this.successMsg = 'Authenticating...'

      const dateFilter = new Date(aaRes['result']['term_dt']) || new Date();
      const currentDate = new Date();

      if (aaRes['result']['termination_date']) this.checkValidDate(aaRes['result']['termination_date']);
      if (aaRes && aaRes['result']['sso_redirect_url']) {
        window.location.replace(aaRes['result']['sso_redirect_url']);
      } else if (aaRes && atob(aaRes['result']['aa_id']) && currentDate.getTime() < dateFilter.getTime()) {
        this.isLoginWait = false
        this.error = true;
        this.errMsg = 'This account has not been verified';
      } else if (this.isTerminated) {
        this.isLoginWait = false
        this.error = true;
        this.errMsg = 'Your account has been terminated';
      } else {
        this.getAmaLoginDetails(jsonData, aaRes['result']['account_id']);
      }
    }
  }

  getAmaLoginDetails(jsonData,acc_id) {
    this.loginService.getAmaLoginDetails(jsonData).subscribe(res => {
      this.success = false;
      this.successMsg = '';
      if (res && res[0]['session_id']) {
        this.loginService.updateLoginActivity({ "aaId": this.aaId, "count": 0, "accId": acc_id}).subscribe(res => {
          this.userCounter = { "user": "", "counter": 0, "lastLog": "" };
          sessionStorage.removeItem("userCounter");
        })
        sessionStorage.setItem('uid', atob(res[0]['session_id']));
        this.selectedAccountId = atob(res[0]['account_id']);
        if (res[0]['website_product_name'] === 'RC2') {
          this.getAccountDetails(this.selectedAccountId);
        } else {
          this.loginService.rc_navigateApplication(this.password, this.username, res);
        }
      } else if (res && res['message']) {
        this.isLoginWait = false
        this.delMsg = true;
        this.message = res['message'];
      } else {
        this.isLoginWait = false
        this.error = true;
        this.errMsg = 'Invalid credentials.';
        this.loginService.updateLoginActivity({ "aaId": this.aaId, "count": 1, "accId": acc_id }).subscribe(res => {
          this.userCounter = { "user": this.username, "counter": res['count'], "lastLog": "" };
          sessionStorage.setItem("userCounter", JSON.stringify(this.userCounter));
          let counter = parseInt(res['count'], 10);
          if (counter > 0 && counter%5 === 0) {
            this.errMsg = 'You have reached the maximum number of attempts. Please try again after some time.';
          } else {
            this.errMsg = 'Invalid credentials.';
          }
        })
      }
    }, err => {
      this.isLoginWait = false
      this.success = false
      if (err.status === 401 || err.status === '401') {
        this.delMsg = true;
        this.message = err['error'].message;
      } else {
        this.error = true;
        this.loginService.updateLoginActivity({ "aaId": this.aaId, "count": 1 }).subscribe(res => {
          this.userCounter = { "user": this.username, "counter": res['count'], "lastLog": "" };
          sessionStorage.setItem("userCounter", JSON.stringify(this.userCounter));
          let counter = parseInt(res['count'], 10);
          if (counter > 0 && counter%5 === 0) {
            this.errMsg = 'You have reached the maximum number of attempts. Please try again after some time.';
          } else {
            this.errMsg = 'Invalid credentials.';
          }
        })
      }
    });
  }

  checkValidDate(dateValue: string = null) {
    const dateFilter = new Date(dateValue);
    const currentDate = new Date();
    this.isTerminated = currentDate.getTime() > dateFilter.getTime() ? true : false
  }

  deleteExistingSession() {
    this.success = false;
    this.error = false;
    const session_id = this.message.split(':')[1];
    sessionStorage.setItem('uid', session_id);
    this.authService.deleteSession(session_id).subscribe(() => {
      this.delMsg = false;
      this.username = '';
      this.password = '';
      sessionStorage.removeItem('uid');
    }, () => {
      this.error = true;
      this.errMsg = 'Error in deleting session'
    });
  }

  public getAccountDetails(accountId: string): void {
    this.authService.getAccountDetails(accountId).subscribe(res => {
      var loggedInDateTime = new Date(this.dateTimePassedByAma);
      var currentDateTime = new Date(res['current_date_time']);
      loggedInDateTime.setMinutes(loggedInDateTime.getMinutes() + 10);
      if (loggedInDateTime < currentDateTime) {
        this.showDanger('Login token time has expired/Invalid token.');
        return;
      }
      sessionStorage['isValidUser'] = true;
      sessionStorage.setItem('accountDetails', JSON.stringify(res[0]));
      sessionStorage.setItem('showFirstTimeWelcome', 'true');
      this.insertGainsight(res[0]);
      if (!this.cdr['destroyed']) this.cdr.detectChanges();
      this.logRocket(res[0]);
      setTimeout(() => {
        this.router.navigate(['/layout']);
      }, 1000);

    }, (err: Response) => {
      this.showDanger('error in service:' + err['error'].message);

    });
  }

  public logRocket(accountDetails: AccountOutput): void {
    if (!this.config) {
      this.globalwindowService.getConfig().subscribe(res => {
        sessionStorage.setItem('config', JSON.stringify(res));
        this.identifyLogRocket(accountDetails, res['CurrentEnvironment']);
      }, (err: Response) => {
        this.logger.error(err['error'].message);
        this.showDanger('error in service:' + err['error'].message);
      });
    } else {
      this.identifyLogRocket(accountDetails, this.config['CurrentEnvironment']);
    }
  }

  private identifyLogRocket(accountDetails: AccountOutput, env: string): void {
    if (env === 'UAT') {
      if (accountDetails.username !== 'AutoFSUser1') {
        LogRocket.init('rj-health/rc3');
        LogRocket.identify('rj-health/rc3', {
          name: accountDetails.username,
          email: accountDetails.email,
        });
      }
    }
  }

  public showDanger(dangerTpl: string): void {
    this.toastService.show(dangerTpl, { classname: 'bg-danger text-light', delay: 15000 });
  }

  public openModal(): void {
    this.display = 'block';
  }

  public onCloseHandled(): void {
    this.display = 'none';
    sessionStorage.clear();
    sessionStorage.removeItem('encKey');
    location.replace(this.config.RC3NewUrl);
  }

  private insertGainsight(accountDetails: AccountOutput) {
    const head = document.getElementsByTagName('head')[0];
    let appId = sessionStorage.getItem('gs')
    const script = document.createElement('script');
    script.innerHTML = `<!-- Gainsight PX Tag-->
                         
                          (function (n, t, a, e, co) {
                              var i = "aptrinsic"; n[i] = n[i] || function () {
                                  (n[i].q = n[i].q || []).push(arguments)
                              }, n[i].p = e; n[i].c = co;
                              var r = t.createElement("script"); r.async = !0, r.src = a + "?a=" + e;
                              var c = t.getElementsByTagName("script")[0]; c.parentNode.insertBefore(r, c)
                          })(window, document, "https://web-sdk.aptrinsic.com/api/aptrinsic.js", "`+ appId + `", {"fullDomainCookie":true});
  
                          aptrinsic('set', 'globalContext', { "Product":"ReimbursementCodes" });
                          //passing user and account objects:
                          aptrinsic("identify",
                              {
                                  //User Fields
                                  "id": "`+ accountDetails.username + `" , // Required for logged in app users
                                  "email": "`+ accountDetails.email + `" ,
                                  "firstName": "`+ accountDetails.contact_first + `",
                                  "lastName": "`+ accountDetails.contact_last + `"
                              },
                              {
                                  //Account Fields
                                  "id":  "`+ accountDetails.org_id + `" , //Required
                                  "name": "`+ accountDetails.org_name + `"
                              });
                      <!-- Gainsight PX Tag-->
                      
                      `;
    head.insertBefore(script, head.lastChild);
  }

}
